import React, { Fragment } from "react";
import { AutocorpLogo } from "@/components/AutocorpLogo";

import SmartphoneVibrateIcon from "@assets/svg/smartphone-vibrate-icon.svg";
import { QR } from "./QR";

export default function QrCode() {
  return (
    <div className="h-full pb-12 flex flex-col bg-white" style={{ height: "100%" }}>
        <main className="flex-grow flex flex-col justify-center max-w-xs w-full mx-auto px-4">
          <div className="pb-8">
            <div className="text-center">
              <h1 className="mt-10 text-xl font-semibold text-gray-900 tracking-tight">Use Your Phone</h1>

              <div className="w-full my-8 flex-shrink-0 flex justify-center">
                <SmartphoneVibrateIcon width={80} />
              </div>

              <p className="my-4 text-base">
                Use the camera app on your phone to scan the QR code below and navigate to the link that will be presented to you.
              </p>

              {/* <img src={SampleQrCode.src} alt="qr-code" /> */}

              <QR />

              {/* <a
                className="flex w-fit text-xs text-blue-700 no-underline cursor-pointer my-6 mx-auto"
                onClick={() => {
                  setHandoffMethod(HANDOFF_METHODS.PHONE);
                  router.push("/id/mobile-handoff");
                }}
              >
                Send me a text instead
              </a> */}

              <p className="mt-8 text-sm">By using this service you agree to Autocorp's <a
                href="https://www.autocorp.ai/terms-of-service"
                target="_blank"
                className=""
              >Terms of Services</a> and <a
                href="https://www.autocorp.ai/privacy-policy"
                target="_blank"
                className=""
              >Privacy Policy</a></p>
            </div>
          </div>
        </main>

        <footer className="flex-shrink-0 max-w-7xl w-full mx-auto px-4">
          <nav className="flex justify-center space-x-4">
            <AutocorpLogo />
          </nav>
        </footer>
      </div>
  );
}